import { gql } from '@apollo/client';

export const GET_CUSTOM_FIELD_SECTIONS = gql`
  query GetCustomFieldSections {
    getCustomFieldSections {
      id
      title
      orderIndex
      fields {
        id
        name
        type
        options
        published
      }
    }
  }
`;

export const CREATE_CUSTOM_FIELD_SECTION = gql`
  mutation CreateCustomFieldSection($title: String!) {
    createCustomFieldSection(title: $title) {
      id
      title
      orderIndex
      fields {
        id
        name
        type
        options
        published
      }
    }
  }
`;

export const UPDATE_CUSTOM_FIELD_SECTION = gql`
  mutation UpdateCustomFieldSection($id: ID!, $title: String!, $fields: [CustomFieldInput!]!) {
    updateCustomFieldSection(id: $id, title: $title, fields: $fields) {
      id
      title
      orderIndex
      fields {
        id
        name
        type
        options
        published
      }
    }
  }
`;

export const DELETE_CUSTOM_FIELD_SECTION = gql`
  mutation DeleteCustomFieldSection($id: ID!) {
    deleteCustomFieldSection(id: $id)
  }
`;

export const TOGGLE_CUSTOM_FIELD_PUBLISHED = gql`
  mutation ToggleCustomFieldPublished($fieldId: String!, $published: Boolean!) {
    toggleCustomFieldPublished(fieldId: $fieldId, published: $published) {
      id
      fields {
        id
        name
        type
        options
        published
      }
    }
  }
`;

export interface LocalField {
  id: string;
  name: string;
  type: string;
  options: string[];
  published?: boolean;
}

export interface LocalSection {
  id: string;
  title: string;
  fields: LocalField[];
}
